/* an object says what it holds as JSON; "[object Object]" says nothing
   and, in a search, would even be found */
export function toText(value: unknown): string {
  if (typeof value === 'object' && value !== null) {
    return JSON.stringify(value);
  }
  return String(value);
}
